import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Tracking from './Tracking';

const RouteManager = ({ title, component: Component, eventName = '', isPrivate, allowMvpd, toCreate }) => {
  const { isAuthenticated, hasMvpd } = useSelector((s) => s.user);
  const { routes } = useSelector((s) => s.appConfig);
  const location = useLocation();
  const params = useParams();

  if (isPrivate && !isAuthenticated && !(allowMvpd && hasMvpd)) {
    let redirectRoute = toCreate ? routes.signupCreateAccount : routes.signin;

    const navigateTo = hasMvpd ? { pathname: routes.myAccount } : { pathname: redirectRoute, search: location.search };

    return <Navigate to={navigateTo} state={{ from: location }} replace />;
  }

  return (
    <Tracking title={title} location={location} eventName={eventName}>
      <Component location={location} params={params} />
    </Tracking>
  );
};

export default RouteManager;
